import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../sidebar/Sidebar";
import { Services } from "../../api/Services";
import { ToastContainer, toast } from "react-toastify";
import gymimage from "../../images/gymgirl.jpg";
import placholder from "../../images/placeholder.png";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';
import ProgramTagsSection from "./ProgramTagsSection";
import ErrorModal from "../common/ErrorModal/ErrorModal";
import "./CreateProgramm.css";
import "components/Attachments/UploadAttachment.css";
import "../workout/components/WorkoutForm.css";
import VideoUploadPopup from "../workout/VideoUploadPopup";

const CreateProgramm = () => {
  // ErrorModal state
  const [showErrorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pendingBack, setPendingBack] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();
  const [communitylist, setCommunityList] = useState([]);
  const [groupList, setGrouplist] = useState([]);
  const [groupId, setGroupId] = useState(null);
  const [communityId, setCommunityId] = useState(null);
  const [userinput, setUserinput] = useState("");
  const [programStartDate, setprogramStartDate] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedusers, setSelectedusers] = useState([]);
  const [usersIds, setUsersIds] = useState([]);

  const [numberOfWeeks, setNumberOfWeeks] = useState(0);
  const [name, setName] = useState("");
  const [isFree, setIsFree] = useState("1");
  const [lock, setLock] = useState("");
  const [assign, setAssign] = useState("self");
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [video, setVideo] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState("");
  const [selectedimage, setSelectedimage] = useState("");
  const [isdisabled, setisdisabled] = useState(false);
  const [isOpenSource, setIsOpenSource] = useState(0);

  // Program video upload state
  const fileInputRef = useRef(null);
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [showVideoUploadPopup, setShowVideoUploadPopup] = useState(false);

  const [activityLevels, setActivityLevels] = useState([]);
  const [ageRanges, setAgeRanges] = useState([]);
  const [genders, setGenders] = useState([]);
  const [bmiRanges, setBmiRanges] = useState([]);
  const [bmrRanges, setBmrRanges] = useState([]);
  const [dcrRanges, setDcrRanges] = useState([]);
  const [fitnessGoals, setFitnessGoals] = useState([]);

  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(currentDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  // Program video upload handlers
  const handleProgramDivClick = () => {
    fileInputRef.current?.click();
  };

  const handleProgramSelectVideo = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setSelectedVideoFile(file);
      setSelectedVideoUrl(url);
    }
  };

  const handleProgramVideoUploaded = async (uploadedUrl) => {
    // Set uploaded URL and create program
    setVideo(uploadedUrl);
    setShowVideoUploadPopup(false);
    setSelectedVideoFile(null);

    const rawData = {
      name,
      users: usersIds.join(", "),
      image,
      desc: description,
      video: uploadedUrl,
      group_id: groupId,
      is_free: isFree,
      price,
      community_id: communityId,
      program_start_date: programStartDate,
      number_of_weeks: numberOfWeeks,
      is_open_source: isOpenSource,
      activity_levels: activityLevels ? activityLevels.join(",") : "",
      age_ranges: ageRanges ? ageRanges.join(",") : "",
      genders: genders ? genders.join(",") : "",
      bmi_ranges: bmiRanges ? bmiRanges.join(",") : "",
      bmr_ranges: bmrRanges ? bmrRanges.join(",") : "",
      dcr_ranges: dcrRanges ? dcrRanges.join(",") : "",
      fitness_goals: fitnessGoals ? fitnessGoals.join(",") : "",
      ...(isFree == "0" ? { lock_future_weeks: lock } : {})
    };

    const data = Object.fromEntries(
      Object.entries(rawData).filter(
        ([_, v]) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "")
      )
    );

    try {
      await createProg(data);
    } catch (e) {
      // handled inside createProg
    }
  };

  const handleCloseVideoUploadPopup = () => {
    setShowVideoUploadPopup(false);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setisdisabled(true);
    setisLoading(true);
    setSelectedimage(URL.createObjectURL(event.target.files[0]));
  };

  //select user
  const toggleItem = (item) => {
    if (selectedusers.includes(item)) {
      setSelectedusers(
        selectedusers.filter((selectedItem) => selectedItem !== item)
      );
      setUsersIds(usersIds.filter((selectedId) => selectedId !== item?.id));
    } else {
      setSelectedusers((prevSelectedUsers) => [...prevSelectedUsers, item]);
      setUsersIds((prevUsersIds) => [...prevUsersIds, item?.id]);
    }
  };

  //remove
  const removeUser = (item) => {
    const confirmed = window.confirm("Do you want to remove user?");
    if (confirmed) {
      if (selectedusers.includes(item)) {
        setSelectedusers(
          selectedusers.filter((selectedItem) => selectedItem !== item)
        );
        setUsersIds(usersIds.filter((selectedId) => selectedId !== item?.id));
      }
    }
  };
  //Upload image api
  const uploadimg = async (data) => {
    try {
      const result = await Services.uploadImage(data);

      if (result.status === 200) {
        setImage(result?.data?.data?.image);
        setSelectedFile(null);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisdisabled(false);
      setisLoading(false);
      setSelectedFile(null);
    } catch (error) {
      console.log(error);
    }
  };

  if (selectedFile) {
    const uploadimagee = new FormData();
    uploadimagee.append("image", selectedFile);
    uploadimg(uploadimagee);
  }

  //handle if free or paid
  const handleFree = (event) => {
    setIsFree(event.target.value);
  };

  const handleOpenSource = (value) => {
    setIsOpenSource(value);
  };

  //handle Lock or not
  const handleLock = (event) => {
    setLock(event.target.value);
  };
  //handle group

  const handleGroupChange = (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setGroupId(newSelectedId);
  };
  const handleCommunityChange = (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setCommunityId(newSelectedId);
  };
  //assign
  const handleAssign = (event) => {
    setAssign(event.target.value);
  };

  //Hanlde user input
  const handleuserinputChange = async (event) => {
    const newInputValue = event.target.value;
    setUserinput(newInputValue);

    try {
      const result = await Services.getProgrammUsers(newInputValue, 1);

      if (result.status === 200) {
        setUsers(result?.data?.data?.listing);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Create programm api

  const createProg = async (data) => {
    setisLoading(true);
    try {
      const result = await Services.createProgram(data);

      if (result.status === 200) {
        toast.success("Program created succesfully", {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });

        localStorage.removeItem("cday");
        localStorage.removeItem("cweek");
        setTimeout(() => {
          navigate(`/programmdetail/${result?.data?.data?.id}`);
        }, 2000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoading(false);
    } catch (error) {
      console.log(error);
    }
  };


  const submitProgramm = () => {
    if (!name) {
      toast.error("Please enter program name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!isFree) {
      toast.error("Please select program is paid or free", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (isFree == "0" && price === 0) {
      toast.error("Please add price value", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (assign === "groups" && !groupId) {
      toast.error("Please select a group", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      if (selectedVideoFile) {
        // Upload first, then create with uploaded URL
        setShowVideoUploadPopup(true);
        return;
      }

      const rawData = {
        name,
        users: usersIds.join(", "),
        image,
        desc: description,
        video,
        group_id: groupId,
        is_free: isFree,
        price,
        community_id: communityId,
        program_start_date: programStartDate,
        number_of_weeks: numberOfWeeks,
        is_open_source: isOpenSource, // allow both Free & Paid to be Public/Private
        activity_levels: activityLevels ? activityLevels.join(",") : "",
        age_ranges: ageRanges ? ageRanges.join(",") : "",
        genders: genders ? genders.join(",") : "",
        bmi_ranges: bmiRanges ? bmiRanges.join(",") : "",
        bmr_ranges: bmrRanges ? bmrRanges.join(",") : "",
        dcr_ranges: dcrRanges ? dcrRanges.join(",") : "",
        fitness_goals: fitnessGoals ? fitnessGoals.join(",") : "",
        ...(isFree == "0" ? { lock_future_weeks: lock } : {})
      };

      // Remove keys with null, undefined, or empty string values
      const data = Object.fromEntries(
        Object.entries(rawData).filter(
          ([_, v]) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "")
        )
      );
      createProg(data);
    }
  };

  // get community list

  useEffect(() => {
    userCommunity();
  }, []);
  const userCommunity = async () => {
    try {
      const result = await Services.getUserCommunity();
      console.log("comunity", result);
      if (result.status === 200) {
        setCommunityList(result?.data?.data);
      } else {
          if (result?.data?.message == "Unauthenticated.") {
          navigate(`/login`);
        }else{
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
       }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get community list

  useEffect(() => {
    userGroups();
  }, []);
  const userGroups = async () => {
    try {
      const result = await Services.getUserGroups();

      if (result.status === 200) {
        setGrouplist(result?.data?.data?.listing);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="wrapper-dashboard">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loader"></div>
        </div>
      )}
      <ToastContainer />

      <div className="create-program-container">
        {/* Back button and page title */}
        <div className="create-program-header">
          <button
            type="button"
            className="back-button"
            onClick={() => {
              // Check if any data is entered
              const hasData =
                name ||
                description ||
                video ||
                image ||
                selectedFile ||
                price ||
                numberOfWeeks ||
                programStartDate ||
                communityId ||
                groupId ||
                usersIds.length > 0 ||
                assign !== "self" ||
                isOpenSource ||
                activityLevels.length > 0 ||
                ageRanges.length > 0 ||
                genders.length > 0 ||
                bmiRanges.length > 0 ||
                bmrRanges.length > 0 ||
                dcrRanges.length > 0 ||
                fitnessGoals.length > 0;
              if (hasData) {
                setErrorMessage("You have entered data. Going back will discard all added data. Do you want to continue?");
                setErrorModal(true);
                setPendingBack(true);
                return;
              }
              localStorage.removeItem("activeSubTab");
              navigate(-1);
            }}
          >
            <span className="back-icon">&larr;</span>
            Back
          </button>
          <h1 className="page-title">Create New Program</h1>
        </div>

        {/* Error Modal */}
        {showErrorModal && pendingBack && (
          <ErrorModal
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            setErrorModal={setErrorModal}
            actionButtonTitle="Yes, Discard"
            handleOK={() => {
              setPendingBack(false);
              localStorage.removeItem("activeSubTab");
              navigate(-1);
            }}
          />
        )}

        <div className="form-card">
          {/* Name */}
          <div className="form-grid">
            <div className="basic-info-section">
              <div className="form-group">
                <label className="form-label">Program name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  placeholder="Enter program name"
                />
              </div>
            </div>
          </div>

          {/* Community and Number of weeks */}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Select a community</label>
              <select
                onChange={handleCommunityChange}
                className="form-select"
                value={communityId || ""}
              >
                <option value="">Select a community</option>
                {communitylist?.map((option) => (
                  <option key={option?.id} value={option?.id}>
                    {option?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Number of weeks</label>
              <select
                className="form-select"
                value={numberOfWeeks}
                onChange={(e) => setNumberOfWeeks(e.target.value)}
              >
                <option value="">Select weeks</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1} week{i > 0 ? 's' : ''}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Program start date */}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Program start date</label>
              <input
                type="date"
                value={programStartDate}
                onChange={(e) => setprogramStartDate(e.target.value)}
                className="form-input"
                min={formattedDate}
              />
            </div>
          </div>

          {/* Price and Privacy */}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Program price</label>
              <div className="radio-group">
                <label className="radio-item">
                  <input
                    type="radio"
                    value="1"
                    checked={isFree == "1"}
                    onChange={handleFree}
                    className="radio-input"
                  />
                  Free
                </label>
                <label className="radio-item">
                  <input
                    type="radio"
                    value="0"
                    checked={isFree == "0"}
                    onChange={handleFree}
                    className="radio-input"
                  />
                  Paid
                </label>
              </div>
              {isFree == "0" && (
                <div className="price-input-section">
                  <label className="form-label">Price (USD)</label>
                  <input
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="form-input"
                    placeholder="Enter price"
                    min="0"
                    step="0.01"
                  />
                </div>
              )}
            </div>

            {window.localStorage.getItem("corporate_identifier") != '23w024s' && (
              <div className="form-group">
                <label className="form-label">Privacy</label>
                <div className="radio-group">
                  <label className="radio-item">
                    <input
                      type="radio"
                      name="visibility"
                      value="1"
                      checked={isOpenSource == 1}
                      onChange={() => handleOpenSource(1)}
                      className="radio-input"
                    />
                    Public
                  </label>
                  <label className="radio-item">
                    <input
                      type="radio"
                      name="visibility"
                      value="0"
                      checked={isOpenSource == 0}
                      onChange={() => handleOpenSource(0)}
                      className="radio-input"
                    />
                    Private
                  </label>
                </div>
              </div>
            )}

            {/* Future weeks locking removed to match EditProgramm */}
          </div>

          {/* Description Section */}
          <div className="description-section" style={{ marginTop: '20px' }}>
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-textarea"
                placeholder="Describe your program..."
                rows={5}
              />
            </div>
          </div>

          {/* YouTube link */}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">YouTube video link</label>
              <input
                type="url"
                value={video && video.includes('firebasestorage.googleapis.com') ? '' : video}
                onChange={(e) => setVideo(e.target.value)}
                className="form-input"
                placeholder="https://youtube.com/watch?v=..."
              />
            </div>
          </div>

          {/* Media Section - Photo and Video */}
          <div className="media-section">
            {/* Photo Upload */}
            <div 
              className={`image-upload-section ${image || selectedimage ? 'has-image' : ''}`}
              onClick={() => document.getElementById('file-input').click()}
            >
              <input
                type="file"
                id="file-input"
                onChange={handleFileChange}
                className="file-input"
                accept="image/*"
              />
              {image || selectedimage ? (
                <div className="image-preview-container">
                  <img
                    src={image ? getImageUrl(image, BASE_URL_MEDIA) : selectedimage}
                    alt="Program"
                    className="image-preview"
                  />
                  <div className="change-image-overlay">
                    <div className="change-image-text">
                      📷<br />
                      Click to change image
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <label className="image-upload-label">Please select a photo</label>
                  <div className="upload-placeholder">
                    <div className="upload-icon">📁</div>
                    <div className="upload-text">Click to upload image</div>
                    <div className="upload-subtext">PNG, JPG, GIF up to 10MB</div>
                  </div>
                </>
              )}
            </div>

            {/* Program Video Upload */}
            <div className={`pw_upload-container ${selectedVideoUrl || video ? "pw_has-media" : ""}`}>
              <label className="pw_upload-label">Program Video</label>
              <span className="pw_upload-help">Upload a video file or use the link field above</span>

              {(selectedVideoUrl || video) && (
                <button
                  type="button"
                  className="pw_change-btn"
                  onClick={handleProgramDivClick}
                  title="Change video"
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}

              <div onClick={handleProgramDivClick} style={{ cursor: "pointer" }}>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleProgramSelectVideo}
                />

                {!selectedVideoUrl && !video ? (
                  <>
                    <div className="pw_upload-icon">
                      <i className="fa fa-video-camera"></i>
                    </div>
                    <div className="pw_upload-text">Upload Video</div>
                    <div className="pw_upload-subtext">
                      Click to select a program video
                    </div>
                  </>
                ) : selectedVideoUrl ? (
                  <>
                    <video className="pw_video-preview" controls src={selectedVideoUrl} />
                    <div className="pw_upload-subtext">Click to change video</div>
                  </>
                ) : (
                  <>
                    {video && !(
                    video.includes("youtube.com") ||
                    video.includes("youtu.be")
                    ) && (
                      <video className="pw_video-preview" controls src={video} />
                    )}
                    <div className="pw_upload-subtext">Click to change video</div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Assignment Section */}
          <div className="search-section form-group">
            <label className="form-label">Create program for</label>
            <div className="radio-group">
              <label className="radio-item">
                <input
                  type="radio"
                  value="self"
                  checked={assign === "self"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                For myself
              </label>
              <label className="radio-item">
                <input
                  type="radio"
                  value="users"
                  checked={assign === "users"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                Assign to others
              </label>
              <label className="radio-item">
                <input
                  type="radio"
                  value="groups"
                  checked={assign === "groups"}
                  onChange={handleAssign}
                  className="radio-input"
                />
                For groups
              </label>
            </div>

            {/* User Search Section */}
            {assign === "users" && (
              <div className="search-section">
                <div className="form-group">
                  <label className="form-label">Search users</label>
                  <input
                    type="text"
                    value={userinput}
                    onChange={handleuserinputChange}
                    placeholder="Type to search users..."
                    className="form-input"
                  />
                </div>

                {/* Selected Users */}
                {selectedusers?.length > 0 && (
                  <ul className="selected-users-list">
                    {selectedusers?.map((suser) => (
                      <li key={suser?.id} className="selected-user-item">
                        <img
                          src={suser?.image ? getImageUrl(suser?.image, BASE_URL_MEDIA) : gymimage}
                          alt={suser?.name}
                          className="selected-user-avatar"
                        />
                        <span>{suser?.name}</span>
                        <button
                          className="remove-user-btn"
                          onClick={() => removeUser(suser)}
                          type="button"
                        >
                          ×
                        </button>
                      </li>
                    ))}
                  </ul>
                )}

                {/* Users Dropdown */}
                {users?.length > 0 && (
                  <div className="users-dropdown">
                    <button
                      className="close-dropdown-btn"
                      onClick={() => setUsers([])}
                      type="button"
                    >
                      ×
                    </button>
                    <ul className="users-list">
                      {users?.map((user) => (
                        <li
                          key={user?.id}
                          className={`user-item ${selectedusers.includes(user) ? "selected" : ""}`}
                          onClick={() => toggleItem(user)}
                        >
                          <img
                            src={user?.image ? getImageUrl(user?.image, BASE_URL_MEDIA) : gymimage}
                            alt={user?.name}
                            className="user-avatar"
                          />
                          <span className="user-name">{user?.name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}

            {/* Group Selection */}
            {assign === "groups" && (
              <div className="search-section">
                <div className="form-group">
                  <label className="form-label">Select a group</label>
                  <select
                    onChange={handleGroupChange}
                    className="form-select"
                    value={groupId || ""}
                  >
                    <option value="">Select a group</option>
                    {groupList?.map((option) => (
                      <option key={option?.id} value={option?.id}>
                        {option?.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>

          {/* Program Tags Section */}
          <div className="search-section">
            <ProgramTagsSection
              activityLevels={activityLevels} setActivityLevels={setActivityLevels}
              ageRanges={ageRanges} setAgeRanges={setAgeRanges}
              genders={genders} setGenders={setGenders}
              bmiRanges={bmiRanges} setBmiRanges={setBmiRanges}
              bmrRanges={bmrRanges} setBmrRanges={setBmrRanges}
              dcrRanges={dcrRanges} setDcrRanges={setDcrRanges}
              fitnessGoals={fitnessGoals} setFitnessGoals={setFitnessGoals}
            />
          </div>

          {/* Submit Button */}
          <div className="submit-section">
            <button
              className="submit-button"
              onClick={submitProgramm}
              disabled={isdisabled}
              type="button"
            >
              Create Program
            </button>
          </div>
        </div>
      </div>
      {showVideoUploadPopup && selectedVideoFile && (
        <VideoUploadPopup
          videoFile={selectedVideoFile}
          workoutId={0}
          onClose={handleCloseVideoUploadPopup}
          onVideoUploaded={handleProgramVideoUploaded}
        />
      )}
    </div>
  );
};

export default CreateProgramm;
